import React, { Component } from 'react'
import logo from '../images/logo.jpeg'

export default class Header extends Component {

    render() {
        return (
            <React.Fragment>
                <header>
                    <nav className="nav-top-padding">
                        <div className="logo-div text-center">
                            <img src={logo} width="150px" />
                        </div>
                        <div className="commn-title-div text-center">
                            {/* <h1>Watch On Time</h1> */}
                            <p>4 catalogues</p>
                        </div>
                    </nav>
                </header>
            </React.Fragment>
        )
    }
}
